"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeGrouping = exports.isValidGroupingOption = exports.groupLevel2Data = exports.getStoredGrouping = exports.getPriceGroupingOptions = exports.NONE_GROUPING_VALUE = exports.GROUPING_STORAGE_KEY = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _numberFormatter = require("../numberFormatter");
var _decimalPlacesHelper = require("../decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var FIXED_GROUPING_VALUES = ['0.01', '0.1', '1', '10', '50', '100', '1000'];
var NONE_GROUPING_VALUE = exports.NONE_GROUPING_VALUE = 'none';
var formatGroupingLabel = function formatGroupingLabel(value) {
  return (0, _numberFormatter.formatNumberToLocale)(value, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(Number(value)));
};
var toOption = function toOption(value) {
  return {
    value: value,
    label: formatGroupingLabel(value)
  };
};

/**
 * Fixed grouping dropdown options: a "None" entry (ungrouped, shows raw price levels)
 * followed by the 7 acceptance-criteria buckets. Unlike an instrument-derived default,
 * this never forces a bucket that's coarser than a sub-cent instrument's real prices
 * (which would collapse its whole book into a single Price: 0 row) - see
 * OrderBookComponent's resolveGrouping, which defaults to no selection at all.
 *
 * @param {Function} t translation function (order namespace)
 * @returns {Array<{value: String, label: String}>}
 */
var getPriceGroupingOptions = exports.getPriceGroupingOptions = function getPriceGroupingOptions(t) {
  return [{
    value: NONE_GROUPING_VALUE,
    label: t('None')
  }].concat(_toConsumableArray(FIXED_GROUPING_VALUES.map(toOption)));
};
var isValidGroupingOption = exports.isValidGroupingOption = function isValidGroupingOption(value, options) {
  return options.some(function (option) {
    return option.value === value;
  });
};

/**
 * Every instrument's grouping lives in a single localStorage record, keyed by instrument id:
 * `{"1":"10","2":"0.1"}`. One record rather than a key per instrument keeps the whole
 * preference readable/clearable in one place instead of accumulating an unbounded number of
 * `orderBookGrouping:<id>` entries as the user visits instruments.
 */
var GROUPING_STORAGE_KEY = exports.GROUPING_STORAGE_KEY = 'orderBookGrouping';

// Anything unparseable or not a plain object (a stale value from another format, a user
// editing localStorage by hand) is treated as "nothing stored" rather than throwing on read.
var readStoredGroupings = function readStoredGroupings() {
  try {
    var parsed = JSON.parse(localStorage.getItem(GROUPING_STORAGE_KEY));
    return parsed && _typeof(parsed) === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    return {};
  }
};

/**
 * @param {Number} instrumentId
 * @param {Array<{value: String, label: String}>} options currently offered options
 * @returns {String|undefined} the stored grouping, or undefined when nothing valid is stored
 */
var getStoredGrouping = exports.getStoredGrouping = function getStoredGrouping(instrumentId, options) {
  var stored = readStoredGroupings()[instrumentId];
  return stored && isValidGroupingOption(stored, options) ? stored : undefined;
};

/**
 * Merges one instrument's grouping into the shared record, leaving the other instruments'
 * entries untouched. No-ops without an instrument id so a selection made before the
 * instrument resolves can't leave an "undefined" entry behind.
 *
 * @param {Number} instrumentId
 * @param {String} grouping
 */
var storeGrouping = exports.storeGrouping = function storeGrouping(instrumentId, grouping) {
  if (instrumentId === undefined || instrumentId === null) return;
  localStorage.setItem(GROUPING_STORAGE_KEY, JSON.stringify(_objectSpread(_objectSpread({}, readStoredGroupings()), {}, _defineProperty({}, instrumentId, grouping))));
};

/**
 * Aggregates level2 price levels into buckets of `grouping` size, summing quantities per bucket.
 * Buy (bid) prices round down to the bucket floor, sell (ask) prices round up to the bucket
 * ceiling, so the displayed grouped price is always conservative relative to the real levels.
 * Visual only - does not mutate the underlying orders used for cancellation/execution.
 *
 * @param {Array} data level2 side data, sorted by Price descending
 * @param {String|Number} [grouping] bucket size, e.g. '0.01'; falsy or NONE_GROUPING_VALUE leaves data ungrouped
 * @param {'buy'|'sell'} side
 */
var groupLevel2Data = exports.groupLevel2Data = function groupLevel2Data(data, grouping, side) {
  if (!data || data.length === 0) return data;
  if (!grouping || grouping === NONE_GROUPING_VALUE) return data;
  var groupSize = new _bignumber["default"](grouping);
  if (!groupSize || groupSize.isNaN() || groupSize.isZero()) return data;
  var roundingMode = side === 'sell' ? _bignumber["default"].ROUND_CEIL : _bignumber["default"].ROUND_FLOOR;
  var groupedByPrice = new Map();
  var groupPriceOrder = [];
  data.forEach(function (item) {
    var price = new _bignumber["default"](item.Price);
    var groupedPrice = price.dividedBy(groupSize).integerValue(roundingMode).multipliedBy(groupSize);
    var key = groupedPrice.toString();
    var existing = groupedByPrice.get(key);
    if (existing) {
      groupedByPrice.set(key, _objectSpread(_objectSpread({}, existing), {}, {
        Quantity: new _bignumber["default"](existing.Quantity).plus(item.Quantity),
        MySize: existing.MySize || item.MySize,
        OrderIds: item.OrderIds ? [].concat(_toConsumableArray(existing.OrderIds || []), _toConsumableArray(item.OrderIds)) : existing.OrderIds
      }));
    } else {
      groupPriceOrder.push(key);
      groupedByPrice.set(key, _objectSpread(_objectSpread({}, item), {}, {
        Price: groupedPrice,
        Quantity: new _bignumber["default"](item.Quantity)
      }));
    }
  });
  return groupPriceOrder.map(function (key) {
    return groupedByPrice.get(key);
  });
};